import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { useMediaAsset } from '~/composables';

interface Props {
  image?: string;
  video?: string;
  videoId?: string;
  title?: string;
  text?: string;
  button?: any;
  features?: any[];
}

interface Emits {
  (e: 'play', data: Props['videoId']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsCarouselSlide',
  props: {
    image: { default: '' },
    video: { default: '' },
    videoId: { default: '' },
    title: { default: '' },
    text: { default: '' },
    button: { default: () => ({}) },
    features: { default: () => [] }
  },
  emits: ["play"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'play', data: Props['videoId']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { image: string, video: string, videoId: string, title: string, text: string, button: any, features: any[] };





const { getAssetUrl } = useMediaAsset();

const videoSrc = computed(() => getAssetUrl(props.video));
const playVideo = () => {
  emit('play', props.videoId);
};

return { __sfc: true,props, emit, getAssetUrl, videoSrc, playVideo }
}

})